export default __webpack_public_path__ + "static/carousel-hero-android-2x-1921c49f5f08afff5bddbf1e6e2a81d5.png";